cv.CustomFieldGroupsRowEmptyView = Marionette.LayoutView.extend({
  tagName : 'div',
  className: 'custom-field-group custom-field-group-empty',
  template : cv.Templates['global/custom_fields_form/custom_field_groups_row_empty'],

  behaviors : [{
    behaviorClass : cv.FormBehavior,
    suppress_notifications: true
  }],

  events : {
  },

  validation: {

  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('CustomFieldGroupsRowEmptyView initialized');
  },

  onShow: function(){
    vent.trigger('custom_field:unlink_group', this);
  },

  onDestroy: function(){
  }
});
